import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PrinterService } from '../printer.service';
import { PrinterHistoryModel } from './printer-history.model';

export interface PrinterHistoryDialogData {
  printerHistoryList: PrinterHistoryModel[]
}

@Component({
  selector: 'printer-history-dialog',
  templateUrl: './printer-history.dialog.html',
  styleUrls: ['./printer-history.dialog.scss']
})

export class PrinterHistoryDialog {  
  
  faCheck = faCheck;
  faTimes = faTimes;

  displayedColumns: string[] = ['shopNumber', 'shopName', 'isActive', 'dateFrom', 'dateTo'];
  
  constructor(
    public printerService: PrinterService,
    public dialogRef: MatDialogRef<PrinterHistoryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: PrinterHistoryDialogData,
  ) { }
}
